// export const cleanFloat = (num) => {
//     if (!num && num !== 0) return 0;

//     const multiplier = 1000; // 10^3 برای ۳ رقم اعشار
//     return Math.round(num * multiplier) / multiplier;
// }


export const cleanFloat = (value, decimals = 3) => {
  const num = Number(value);

  if (!Number.isFinite(num)) {
    return 0;
  }

  const multiplier = 10 ** decimals;

  return Math.round((num + Math.sign(num) * Number.EPSILON) * multiplier) / multiplier;
};